import { render, staticRenderFns } from "./StateTypeMain.vue?vue&type=template&id=4b4b2b0c&scoped=true&"
import script from "./StateTypeMain.vue?vue&type=script&lang=js&"
export * from "./StateTypeMain.vue?vue&type=script&lang=js&"
import style0 from "./StateTypeMain.vue?vue&type=style&index=0&id=4b4b2b0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4b2b0c",
  null
  
)

export default component.exports